import type { WhoamiMe } from "@shared-domain/auth-service/contract";

/**
 * PRODUCT_DEV-748: フロントの権限判定。もとは `components/shared/AdminLayout.tsx` に
 * 同居していたが、**純粋な判定ロジックなのに管理者画面レイアウトを引き連れてくる**
 * のが問題だった（メモ画面や ToDo タブも admin 判定を使うため、Minizo の dist にまで
 * 管理者画面のレイアウトが入ってしまう）。
 *
 * AdminLayout 側にあった `react-refresh/only-export-components` の disable も、
 * 「コンポーネントのファイルから非コンポーネントを export している」ことが原因なので
 * ここへ移すと不要になる。
 *
 * 判定そのものは移動前と同一（改ざんは許容。サーバ側の認可が正）。
 */

/**
 * フロントでのadmin権限チェック（改ざんは許容）
 */
export const checkRoleIsAdmin = (auth: WhoamiMe): boolean => {
  if (!auth || !auth.currentTenantId || !auth.info) {
    return false;
  }
  const tenantId = auth.currentTenantId;
  const productId = auth.info.productId;
  const membership = auth.memberships.find(
    (x) =>
      x.tenantId === tenantId && x.products.some((p) => p.id === productId),
  );
  if (!membership) {
    return false;
  }
  return membership.role === "admin";
};

/**
 * フロントでのsysadmin権限チェック（admin + specialFlags["sysadmin"]）
 */
export const checkRoleIsSysadmin = (auth: WhoamiMe): boolean => {
  if (!checkRoleIsAdmin(auth)) return false;
  const tenantId = auth.currentTenantId;
  const productId = auth.info!.productId;
  const membership = auth.memberships.find(
    (x) =>
      x.tenantId === tenantId && x.products.some((p) => p.id === productId),
  );
  return membership?.specialFlags?.includes("sysadmin") ?? false;
};
